module.exports = __webpack_public_path__ + "img/sock_in_book.91d2f396.jpg";